export default "__VITE_ASSET__B48F8jCd__"